/**
 * Tour demos - Main aggregator
 * Combines common demos with all module-specific demos
 */

import type { TourDemoType } from '../types'
import { getCommonDemoHTML } from './common-demos'
import { getDayoffDemoHTML } from './dayoff-demos'
import { getBusinessDemoHTML } from './business-demos'
import { getCustomerDemoHTML } from './customer-demos'
import { getEmployeeDemoHTML } from './employee-demos'

/**
 * Generate demo HTML based on demo type
 * Tries all demo sources in order: common → dayoff → business → customer → employee
 */
export const getDemoHTML = (demo?: TourDemoType): string => {
    // Try each demo source
    return (
        getCommonDemoHTML(demo) ||
        getDayoffDemoHTML(demo) ||
        getBusinessDemoHTML(demo) ||
        getCustomerDemoHTML(demo) ||
        getEmployeeDemoHTML(demo) ||
        ''
    )
}

// Re-export individual demo functions for direct use if needed
